export default __webpack_public_path__ + "static/0267-e2f7c2d034a2e05fddff40d869305908.png";